const Fetching = () => <div />

export default Fetching
